import React from 'react';
import { ToolTip } from '@trp-beacon-ui-kit/react-communication';
import { getQueryVariable } from '../../core/util';
import {
  accountTypes,
  chargeTypes,
  redirectToAccountFinder
} from '../../flows/shared/utils';

export const provideFieldDefault = (
  condition,
  defaultWhenConditionTrue,
  defaultWhenConditionFalse
) =>
  condition
    ? defaultWhenConditionTrue
    : defaultWhenConditionFalse?.defaultValue;

export const retirementTypeHeaderDisplay = {
  TRADITIONAL: 'Traditional IRA',
  SEP: 'SEP-IRA',
  ROTH: 'Roth IRA',
  ROLLOVER: 'Rollover IRA'
};

export const getRetirementTypeDisplay = type => {
  return retirementTypeHeaderDisplay[type];
};

export const brkAccountTransferType = {
  TRADITIONAL: 'traditional',
  ROTH: 'roth',
  ROLLOVER: 'rollover',
  SEP: 'sep'
};

export const getBRKTransferType = type => {
  return brkAccountTransferType[type];
};

export const getHeaderText = (
  authenticated,
  firstName,
  accountType,
  fromIRAAccountType,
  iraAccountType
) => {
  const accountHeaderText = `Let's ${{
    TRANSFER_IRA: 'move',
    ROLLOVER_IRA: 'start',
    CONTRIBUTORY_IRA: 'open',
    TRUST: 'start'
  }[accountType] || 'open'} your ${{
    TRANSFER_IRA: getRetirementTypeDisplay(fromIRAAccountType),
    ROLLOVER_IRA: 'Rollover IRA',
    CONTRIBUTORY_IRA: getRetirementTypeDisplay(iraAccountType),
    INDIVIDUAL: 'general investing account',
    JOINT_TENANT: 'general investing account',
    UGMA_UTMA: 'UGMA/UTMA account',
    TRUST: 'trust account'
  }[accountType] || 'new account'}`;

  return authenticated && firstName
    ? `${accountHeaderText}, ${firstName}`
    : accountHeaderText;
};

const setTaxableLeadingHeaderText = (accountType, chargeType) => {
  let leadingTxt = `Let's ${{
    TRUST: 'start'
  }[accountType] || 'open'}`;

  if (chargeType === chargeTypes.TRANSFER) leadingTxt = `Let's move`;

  return leadingTxt;
};

export const getTaxableProfileHeaderText = (
  authenticated,
  firstName,
  accountType,
  chargeType
) => {
  const leadingAccountHeaderText = setTaxableLeadingHeaderText(
    accountType,
    chargeType
  );

  const trailingAccountHeaderText = `your ${{
    INDIVIDUAL: 'general investing account',
    JOINT_TENANT: 'general investing account',
    UGMA_UTMA: 'UGMA/UTMA account',
    TRUST: 'trust account'
  }[accountType] || 'new account'}`;

  return authenticated && firstName
    ? `${leadingAccountHeaderText} ${trailingAccountHeaderText}, ${firstName}`
    : `${leadingAccountHeaderText} ${trailingAccountHeaderText}`;
};

export const redirectRolloverNoAuth = (rpsDirectRollover, authenticated) => {
  if (rpsDirectRollover && !authenticated) {
    redirectToAccountFinder();
  }
};

export const getURLTickers = qs => {
  // example of qs -> "?selectedFund=TRBCX,PRGFX"
  const tickers = qs ? getQueryVariable(qs, 'selectedFund') : false;

  if (tickers) {
    // split resulting string into array on ',' separator -> ["ABCDE", "12345"]
    // map to expected object schema - [{ticker: 'ABCDE'}, {ticker: '12345'}]
    return tickers.split(',').map(t => ({
      ticker: t
    }));
  }

  // if tickers is false ('selectedFund' is not found in qs)
  return false;
};

export const renderPrimaryEmailTitleWithTooltip = () => (
  <>
    Email address{' '}
    <ToolTip
      id="tooltip_primary-email-address"
      role="alert"
      popOutPlacement="top"
      description="We will use this to send your confirmation email"
    />
  </>
);

export const renderDobTitleWithTooltip = () => (
  <>
    Date of Birth{' '}
    <ToolTip
      id="tooltip_dateofbirth"
      role="alert"
      popOutPlacement="top"
      description="If you decide you want an investment recommendation, knowing your date of birth can inform our advice"
    />
  </>
);

export const renderAmountTitleWithTooltip = accountType => {
  const titleText =
    accountType === accountTypes.TRUST
      ? "Amount you'd like to invest "
      : 'Enter the amount you expect to invest. You can change this later. ';
  return (
    <>
      {titleText}
      <ToolTip
        id="tooltip_amount"
        role="alert"
        popOutPlacement="top"
        description="This helps us tailor your investment options. Feel free to enter an estimate for now"
      />
    </>
  );
};
